<template>
  <v-app id="app">
    <v-snackbar
      v-model="$store.getters.msg.show"
      :color="$store.getters.msg.color"
      multi-line="multi-line"
      v-bind:timeout="$store.getters.msg.timeout"
      top="top"
    >
      {{ $store.getters.msg.message }}
      <v-btn dark text @click="$store.commit('msgOculta')"> Close </v-btn>
    </v-snackbar>

    <!-- Snackbar de actualización de versión -->
    <v-snackbar
      v-model="updateExists"
      :timeout="-1"
      color="primary"
      top
      multi-line
    >
      <v-icon left color="white">mdi-update</v-icon>
      <strong>Nueva versión disponible</strong>
      <div class="text-caption mt-1">
        Actualiza para obtener las últimas mejoras
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="refreshApp">
          <v-icon left>mdi-refresh</v-icon>
          Actualizar
        </v-btn>
        <v-btn icon v-bind="attrs" @click="updateExists = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-navigation-drawer
      v-model="drawer"
      app
      v-if="$store.getters.token"
      color="#1B6BAA"
    >
      <v-list dense>
        <v-list-item
          link
          v-for="(item, index) in menu"
          :key="index"
          :to="item.action"
        >
          <v-list-item-action>
            <v-icon class="white--text">{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="white--text">{{
              item.title
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar app color="#1B6BAA" dark v-if="$store.getters.token">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>{{ $store.getters.title }}</v-toolbar-title>
      <v-spacer />
      <v-btn icon large>
        <v-avatar size="42px" item>
          <v-img src="@/assets/images/icono.png" alt="PRIMA"
        /></v-avatar>
      </v-btn>
    </v-app-bar>

    <v-content :class="{ azul: !$store.getters.token }">
      <v-container fluid>
        <router-view />
      </v-container>
    </v-content>
    <v-footer color="#1B6BAA" app v-if="$store.getters.token">
      <div class="white--text text-right" style="width: 100%">
        &copy; 2020 Prima Waste Removal
      </div>
    </v-footer>
  </v-app>
</template>
<style scoped>
.azul {
  background: #1b6baa;
}
</style>
<script>
export default {
  name: "App",
  props: {
    source: String,
  },
  data: () => ({
    drawer: false,
    updateExists: false,
    registration: null,
    refreshing: false,
    menu: [
      { icon: "mdi-home", title: "Home", action: "/" },
      {
        icon: "mdi-check",
        title: "Pre Trip Inspection",
        action: "/pre-trip-inspection",
      },
      { icon: "mdi-directions", title: "Routes", action: "/routes" },
      {
        icon: "mdi-check-all",
        title: "Post Trip Inspection",
        action: "/post-trip-inspection",
      },
      { icon: "mdi-pen", title: "Signature", action: "/signature" },
      { icon: "mdi-logout", title: "QR Test", action: "/test" },
      { icon: "mdi-logout", title: "Logout", action: "/logout" },
    ],
    managerMenusAdded: false,
  }),
  components: {},
  computed: {
    isManager() {
      return this.$store.getters.driver_type == "Manager";
    },
  },
  watch: {
    // Observar cuando cambia el tipo de driver
    isManager: {
      immediate: true,
      handler(newVal) {
        if (newVal && !this.managerMenusAdded) {
          this.addManagerMenus();
        } else if (!newVal && this.managerMenusAdded) {
          this.removeManagerMenus();
        }
      },
    },
  },
  methods: {
    addManagerMenus() {
      // Verificar si ya existen los menús para evitar duplicados
      const hasModifyRoutes = this.menu.some(
        (item) => item.action === "/swap-routes",
      );
      const hasCustomers = this.menu.some(
        (item) => item.action === "/customers",
      );

      if (!hasModifyRoutes && !hasCustomers) {
        console.log("Adding Manager menus");
        this.menu.splice(5, 0, {
          icon: "mdi-swap-horizontal",
          title: "Modify Routes",
          action: "/swap-routes",
        });
        this.menu.splice(6, 0, {
          icon: "mdi-account-multiple",
          title: "Customers",
          action: "/customers",
        });
        this.managerMenusAdded = true;
      }
    },
    removeManagerMenus() {
      // Remover los menús de manager cuando se desloguea
      this.menu = this.menu.filter(
        (item) =>
          item.action !== "/swap-routes" && item.action !== "/customers",
      );
      this.managerMenusAdded = false;
    },
    showRefreshUI(e) {
      // Guardar el registration para usarlo luego
      this.registration = e.detail;
      this.updateExists = true;
    },
    refreshApp() {
      this.updateExists = false;
      // Prevenir que se dispare múltiples veces
      if (!this.refreshing) {
        this.refreshing = true;
        // Si hay un service worker esperando, activarlo
        if (this.registration && this.registration.waiting) {
          this.registration.waiting.postMessage({ type: "SKIP_WAITING" });
        }
        // Recargar la página para aplicar la actualización
        window.location.reload();
      }
    },
  },
  created() {
    // Escuchar el evento de actualización del service worker
    document.addEventListener("swUpdated", this.showRefreshUI, { once: true });

    // Recargar la página cuando el service worker se active
    navigator.serviceWorker?.addEventListener("controllerchange", () => {
      if (this.refreshing) return;
      this.refreshing = true;
      window.location.reload();
    });
  },
  mounted: function () {
    var token = this.$ls.get("token", false);
    var driver_id = this.$ls.get("driver_id", 0);
    var signature = this.$ls.get("signature", false);
    var driver_type = this.$ls.get("driver_type", "");
    var driver_onesignal = this.$ls.get("driver_onesignal", "");
    if (token && driver_id) {
      var datos = {
        token: token,
        driver_id: driver_id,
        signature: signature,
        type: driver_type,
        driver_onesignal: driver_onesignal,
      };
      this.$store.commit("login", datos);
      // Los menús se agregarán automáticamente por el watcher
    }
  },
};
</script>
